import { wrapInput } from '@danderson00/react-forms'
import { DropDown as DropDownWidget } from '../widgets'
export const FormDropDown = wrapInput(DropDownWidget, { valueFromEvent: x => x })

export const DropDown = ({ name, options, ...props }) => {
  const validateDropDown = (indexSelected) => indexSelected === undefined && 'Please select an option'

  return <FormDropDown
    name={name}
    options={options}
    getValidationMessage={validateDropDown}
    {...props}
  />
}

